<template lang="html">

  <div class="geo"
    v-click-outside="autocompleteUnsetFocus"
    :class="{'active': autocompleteFocused}"
  >

    <autocomplete
      :source="urlFunction"
      results-property="items"
      :results-display="formatDisplay"
      v-model="tags"
      :placeholder="placeholder"
      @focus="autocompleteSetFocus"
      @results="autocompleteUnsetFocus"
      @clear="clear"
      >
    </autocomplete>

    <!-- <dropdown-transition>
    </dropdown-transition> -->
    <div
      class="geo-dropdown"
      v-if="autocompleteFocused"
    >

      <input-tag :tags.sync="tags" v-if="tags.length"></input-tag>

      <div class="geo-drpdown-placeholder" v-if="!tags.length">
        Начните вводить или выберите объект в выпадающем списке
      </div>


      <div class="geo-drpdown-list">
        <div v-for="(geo, key) in lists" v-if="geo.locations.length" class="geo-drpdown-list__block" :class="{'active' : currentList == key}">
          <a class="geo-drpdown-list__title" href="#" @click.prevent="switchList(key)">{{ geo.label }}</a>
          <collapse-transition>
            <geo-checkboxes-list
              v-show="currentList == key"
              v-model="tags"
              :options="geo.locations"
              @unFocus="autocompleteUnsetFocus"
            ></geo-checkboxes-list>
          </collapse-transition>
        </div>
      </div>

    <!--
      <portal :to="currentList" :disabled="false" slim>
        <geo-checkboxes-list
          v-model="tags"
          :options="$data[currentList]"
          @unFocus="autocompleteUnsetFocus"
        ></geo-checkboxes-list>
      </portal>

      <div class="geo-drpdown-list">
        <div class="geo-drpdown-list__block" :class="{'active' : currentList == 'metros'}">
          <a class="geo-drpdown-list__title" href="#" @click.prevent="switchList('metros')">Метро</a>
          <collapse-transition>
            <portal-target name="metros" slim ></portal-target>
          </collapse-transition>
        </div>

        <div class="geo-drpdown-list__block" :class="{'active' : currentList == 'districts'}">
          <a class="geo-drpdown-list__title" href="#" @click.prevent="switchList('districts')">Район</a>
          <collapse-transition>
            <portal-target name="districts" slim ></portal-target>
          </collapse-transition>
        </div>

        <div class="geo-drpdown-list__block" :class="{'active' : currentList == 'jk'}">
          <a class="geo-drpdown-list__title" href="#" @click.prevent="switchList('jk')">ЖК</a>
          <collapse-transition>
            <portal-target name="jk" slim ></portal-target>
          </collapse-transition>
        </div>

      </div>
    -->
    </div>

  </div>
</template>

<script>
  import autocomplete from './autocomplete'
  import geoCheckboxes from './geo-checkbox'
  import geoCheckboxesList from './geo-checkboxes-list'
  import inputTag from './input-tag'
  // import dropdownTransition from '../transitions/dropdown'

  import assign from '../../assign';

  import uniqBy from 'lodash/uniqBy'
  import isEqual from 'lodash/isEqual'
  import map from 'lodash/map'
  import trim from 'lodash/trim'

  export default {
    name: 'geo',

    components: {
      autocomplete,
      geoCheckboxes,
      geoCheckboxesList,
      inputTag,
      // dropdownTransition,
    },

    model: {
      prop: 'modelValue',
      // event: 'input'
      event: 'change'
    },

    props: {
      lists:{
        default: function() {
          return []
        }
      },
      placeholder: {
        default: undefined
      },
      modelValue: {
        default: function() {
          return []
        }
      }
    },

    data() {
      return {
        autocompleteFocused: false,
        currentList: 'empty',
        empty: [],
        // DONE: fetch
        tags: [],
      }
    },

    mounted() {
      this.tags = this.modelValue;
    },

    watch: {

      lists(newValue, oldValue) {
        console.log("geo watch lists", newValue);
      },

      // autocompleteFocused(newValue, oldValue) {
      //   console.log("autocompleteFocused newValue", newValue);
      // },

      tags(newValue, oldValue) {
        // console.log("geo watch tags", newValue);

        // generate placeholder
        if (newValue.slice(0).length) {
          // let placeholder = map(newValue, 'text');
          let placeholder = map(newValue, (tag) => this.formatDisplay(tag));
          this.$parent.geoSelectedString = placeholder.join(', ');
        } else {
          this.$parent.geoPlaceholder = this.$parent.initialGeoPlaceholder;
        }

        // check for duplets on newValue
        if (!isEqual(newValue, oldValue)) {
          this.$emit('change', uniqBy(newValue, 'text'))
        }

      }
    },

    methods: {
      lat2cyr( str ) {
        let replacer = {
            "q":"й", "w":"ц", "e":"у", "r":"к", "t":"е", "y":"н", "u":"г",
            "i":"ш", "o":"щ", "p":"з", "[":"х", "]":"ъ", "a":"ф", "s":"ы",
            "d":"в", "f":"а", "g":"п", "h":"р", "j":"о", "k":"л", "l":"д",
            ";":"ж", "'":"э", "z":"я", "x":"ч", "c":"с", "v":"м", "b":"и",
            "n":"т", "m":"ь", ",":"б", ".":"ю", "/":"."
        };

        return str.replace(/[A-z/,.;\'\]\[]/g, function ( x ){
            return x == x.toLowerCase() ? replacer[ x ] : replacer[ x.toLowerCase() ].toUpperCase();
        });
    },

      // $('#txt').keyup(function(e){ if($(this).val().match(/([а-яА-Я]+)/)){ alert('Смените раскладку'); }
      // https://javascript.ru/forum/jquery/34739-avtomaticheskaya-smena-raskladki.html
      // lat2cyr(str) {
      //   str = str.replace(/^\s+|\s+$/g, ''); // trim
      //   str = str.toLowerCase();
      //
      //   str = str.replace(/_+/g, '-');
      //   str = str.replace(/"+/g, '');
      //   // remove accents, swap n for n, etc
      //   var from = ["а", "б", "в", "г", "д", "е", "ё", "ж", "з", "и", "й", "к", "л", "м", "н", "о", "п", "р", "с", "т", "у", "ф", "х", "ц", "ч", "ш", "щ", "ъ", "ы", "ь", "э", "ю", "я", "А", "Б", "В", "Г", "Д", "Е", "Ё", "Ж", "З", "И", "Й", "К", "Л", "М", "Н", "О", "П", "Р", "С", "Т", "У", "Ф", "Х", "Ц", "Ч", "Ш", "Щ", "Ы", "Ь", "Э", "Ю", "Я", "_", ",", ":", ";", '"', "'", "«", "»"];
      //
      //   var to   = ["a", "b", "v", "g", "d", "e", "e", "zh", "z", "i", "y", "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "f", "h", "c", "ch", "sh", "sch", "", "y", "", "e", "yu", "ya", "a", "b", "v", "g", "d", "e", "e", "zh", "z", "i", "y", "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "f", "h", "c", "ch", "sh", "sch", "", "y", "", "e", "yu", "ya", "-", "-", "-", "-", "", "", "", "" ];
      //
      //   for (var i=0, l=from.length ; i<l ; i++) {
      //     str = str.replace(new RegExp(from[i], 'g'), to[i]);
      //   }
      //
      //   str = str.replace(/\s+/g, '-') // collapse whitespace and replace by -
      //     .replace(/-+/g, '-'); // collapse dashes
      //
      //   return str;
      // },

      clear(){
        this.tags = []
        this.$emit('change', this.tags)
        this.autocompleteUnsetFocus();
      },

      switchList(list){
        if (this.currentList == list) {
          list = 'empty'
        }
        this.currentList = list;
      },

      urlFunction(input) {
        let initialInput = input;
        input = this.lat2cyr(input);
        // DONE: вынести адрес в конфиг
        // return _GD.dkf.url.typeahead + '?q=' + input + '&locality=' // TODO: add localitty add estate type
        // return _GD.dkf.url.typeahead + input;
        return _GD.dkf.url.typeahead +'?locality='+this.$parent.fData.locality+'&estate_group='+this.$parent.fData.estate_group+'&q='+ input+'&q1='+ initialInput;
        // return 'http://kladr-api.ru/api.php?token=5a9190bd7c8aab1b278b456c&contentType=street&limit=20&cityId=5400000100000&query=' + input;
      },
      formatDisplay(result) {
        if (_GD.dkf.constants.locality_types[result.type]) {
          result = assign(result, _GD.dkf.constants.locality_types[result.type]);
        }
        return trim(result.pfx + ' ' + result.text + ' ' + result.sfx)
      },
      autocompleteUnsetFocus(){
        this.autocompleteFocused = false
        this.currentList = 'empty';
      },
      autocompleteSetFocus(e){
        this.autocompleteFocused = true
      },
    },

    directives: {
      'click-outside': {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
          	const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn)
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
            	binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
          document.addEventListener('touchstart', handler)
  			},

        unbind: function(el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          document.removeEventListener('touchstart', el.__vueClickOutside__)
          el.__vueClickOutside__ = null

        }
      }
    }
  }
</script>

<style lang="scss">


@keyframes _fadein {
    from { opacity: 0; transform: scale(.95); }
    to   { opacity: 1; transform: scale(1); }
}

.geo{
  z-index: 10;
  position: relative;
  .geo-dropdown {
    animation: _fadein .35s;
    position: absolute;
    width: 100%;
    background: #fff;
    margin-top: 3px;
    border: 0;
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.2);
  }
  .geo-drpdown-placeholder{
    width: 100%;
    padding: 10px;
    padding-right: 30%;
    font-size: 13px;
    color: #999;
    border-bottom: 1px solid #e6e6e6;
  }
  .geo-drpdown-list__block{
    border-bottom: 1px solid #e6e6e6;
    .geo-drpdown-list__title{
      padding: 8px 10px;
      color: #333;
      font-size: 14px;
      display: block;
      width: 100%;
      position: relative;
      &:hover{
        background-color: #e7e7e7;
      }
      &:after{
        position: absolute;
        right: 15px;
        content: "";
        width: 12px;
        display: inline-block;
        vertical-align: middle;
        height: 20px;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMS44IDYuOSI+CiAgPHBhdGggZmlsbD0iIzljOWQ5ZSIgZD0iTTUuOSA3YTEgMSAwIDAgMS0uNy0uNGwtNS00LjlBMSAxIDAgMCAxIC4zLjNhMSAxIDAgMCAxIDEuNSAwTDYgNC41IDEwLjEuM2ExIDEgMCAwIDEgMS40IDBjLjQuNC40IDEgMCAxLjRsLTUgNWExIDEgMCAwIDEtLjYuMnoiLz4KPC9zdmc+");
        background-position: 50% 50%;
        // background-size: 130%;
        background-repeat: no-repeat;
      }
    }
    &.active{
      .geo-drpdown-list__title{
        &:after{
          transform: scale(-1);
          transition: all .35s ease;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/geo/geo.vue